import BoardIcon from '@atlaskit/icon/core/board';
import { Inline } from '@atlaskit/primitives';

export type WorkspaceProp = {
  name: string;
  boardCount: number;
};

export default function Workspace({ name, boardCount }: WorkspaceProp) {
  return (
    <Inline alignBlock="center">
      <Inline grow="fill" alignBlock="center">
        {name}
      </Inline>
      <Inline grow="fill" space="space.100" alignBlock="center">
        <BoardIcon label="" />
        {boardCount ?? 0} Boards
      </Inline>
    </Inline>
  );
}
